import SideMenu from "../../components/menu/side-menu";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  matchPath,
} from "react-router-dom";
import IndexSolicitudesCompra from "../order-solicitudes";
import ApprovalsSolicitudesCompra from "../order-solicitudes/approvals";
import ConfirmsSolicitudesCompra from "../order-solicitudes/confirms";
import MaintenanceSolicitudesCompra from "../order-solicitudes/maintenance";
import NewSolicitudCompra from "../order-solicitudes/new-solicitude";
import IndexOrdenesCompra from "../order-purchases/index";
import ApprovalsOrdenesCompra from "../order-purchases/approvals";
import MaintenanceOrdenesCompra from "../order-purchases/maintenance";
import NewOrdenCompra from "../order-purchases/new-order";
import IndexBoxHome from "./indexboxhome";
import PresupuestoCarga from "../presupuesto/crea-presupuesto";
import IndexPresupuesto from "../presupuesto/index";
import "./index.css";
import { InitDataForTablesProvider } from "../../context/InitDataForTables";
import { InitDataContableProvider } from "../../context/InitDataContable";
import ConfirmsOrdenesCompra from "../order-purchases/confirms";
import Error404 from "../../components/static-pages/error404";
import ValidateSignatureSolicitude from "../static-pages/validate-signature-solicitude";
import ValidateSignatureOrder from "../static-pages/validate-signature-order";
import { InitDataNewOrderProvider } from "../../context/InitDataNewOrder";
import { InitDataProvider } from "../../context/InitDataContext";
import LoadSpinner from "../../components/ui/LoadSpinner";
import { ViewportProvider } from "../../context/ViewportContext";
import OrdenesHighAmount from "../order-purchases/order-high-amounts";
import SeguimientoCorreosOrdenes from "../order-purchases/email-tracking";
import { useState } from "react";
import IndexFinanzas from "../finanzas";
import MaintenanceFinanzas from "../finanzas/maintenance";
import IndexContabilidad from "../contabilidad";
import MaintenanceContabilidad from "../contabilidad/maintenance";
import NetworkStatusAlert from "../../components/ui/NetworkStatusAlert";
import AppInfoBar from "../../components/ui/app-info-bar/AppInfoBar";

const CheckPathMatch = (path: string, element: any) => {
  const location = useLocation();
  const match = matchPath(path, location.pathname);

  if (match) {
    return element;
  } else {
    return <Error404 />;
  }
};

function IndexHome() {
  const [isOpenMenu, setIsOpenMenu] = useState(true);
  const leftBoxWidth = isOpenMenu ? "15%" : "5%";
  const rightBoxWidth = isOpenMenu ? "85%" : "92%";

  return (
    <>
      <InitDataProvider>
        <NetworkStatusAlert />
        <ViewportProvider>
          <div
            className="mainBoxContainer"
            style={{ display: "flex", width: "100vw", minHeight: "100vh" }}
          >
            {/* LEFT BOX: Bound directly to React layout engine calculations */}
            <div
              id="leftBox"
              className="leftBox"
              style={{
                width: leftBoxWidth,
                /* FIXED: Changed to minHeight auto/inherit so it stretches as long as its content demands */
                minHeight: "100vh",
                height: "auto",
                transition: "width 0.22s cubic-bezier(0.25, 0.8, 0.25, 1)",
                /* FIXED: Removed overflow hidden here so the menu can extend all the way down */
                overflow: "visible",
              }}
            >
              <SideMenu isOpenMenu={isOpenMenu} setIsOpenMenu={setIsOpenMenu} />
            </div>

            {/* RIGHT BOX */}
            <div
              id="rightBox"
              className="rightBox"
              style={{
                width: rightBoxWidth,
                minHeight: "100vh",
                height: "auto",
                transition: "width 0.22s cubic-bezier(0.25, 0.8, 0.25, 1)",
                /* Column: info bar on top, then the screen */
                display: "flex",
                flexDirection: "column",
              }}
            >
              <AppInfoBar />
              <div className="app-main">
                <Routes>
                  <Route path="/" element={<IndexBoxHome />} />
                  <Route
                    path="/solicitudes-compra"
                    element={<IndexSolicitudesCompra />}
                  />
                  <Route
                    path="/solicitudes-compra/nueva"
                    element={
                      <InitDataForTablesProvider>
                        <NewSolicitudCompra />
                      </InitDataForTablesProvider>
                    }
                  />
                  <Route
                    path="/solicitudes-compra/aprobacion"
                    element={
                      <InitDataForTablesProvider>
                        <ApprovalsSolicitudesCompra />
                      </InitDataForTablesProvider>
                    }
                  />

                  <Route
                    path="/solicitudes-compra/confirmacion"
                    element={
                      <InitDataForTablesProvider>
                        <ConfirmsSolicitudesCompra />
                      </InitDataForTablesProvider>
                    }
                  />

                  <Route
                    path="/solicitudes-compra/mantencion"
                    element={
                      <InitDataForTablesProvider>
                        <MaintenanceSolicitudesCompra />
                      </InitDataForTablesProvider>
                    }
                  />

                  <Route
                    path="/ordenes-compra"
                    element={<IndexOrdenesCompra />}
                  />
                  <Route
                    path="/ordenes-compra/nueva"
                    element={
                      <InitDataNewOrderProvider>
                        <NewOrdenCompra />
                      </InitDataNewOrderProvider>
                    }
                  />
                  <Route
                    path="/ordenes-compra/aprobacion"
                    element={
                      <InitDataForTablesProvider>
                        <ApprovalsOrdenesCompra />
                      </InitDataForTablesProvider>
                    }
                  />
                  <Route
                    path="/ordenes-compra/mantencion"
                    element={
                      <InitDataNewOrderProvider>
                        <InitDataForTablesProvider>
                          <MaintenanceOrdenesCompra />
                        </InitDataForTablesProvider>
                      </InitDataNewOrderProvider>
                    }
                  />

                  <Route
                    path="/ordenes-compra/confirmacion"
                    element={
                      <InitDataForTablesProvider>
                        <ConfirmsOrdenesCompra />
                      </InitDataForTablesProvider>
                    }
                  />

                  <Route
                    path="/ordenes-compra/visualizar-montos-altos"
                    element={
                      <InitDataForTablesProvider>
                        <OrdenesHighAmount />
                      </InitDataForTablesProvider>
                    }
                  />

                  <Route
                    path="/ordenes-compra/seguimiento-correos"
                    element={<SeguimientoCorreosOrdenes />}
                  />

                  <Route path="/presupuestos" element={<IndexPresupuesto />} />
                  <Route
                    path="/presupuestos/nuevo"
                    element={
                      <InitDataContableProvider>
                        <PresupuestoCarga />
                      </InitDataContableProvider>
                    }
                  />

                  <Route path="*" element={<Error404 />} />

                  <Route
                    path="/validar-firma-solicitud"
                    element={<ValidateSignatureSolicitude />}
                  />
                  <Route
                    path="/validar-firma-orden"
                    element={<ValidateSignatureOrder />}
                  />

                  <Route path="/finanzas" element={<IndexFinanzas />} />
                  <Route
                    path="/finanzas/seguimiento"
                    element={<MaintenanceFinanzas />}
                  />

                  <Route path="/contabilidad" element={<IndexContabilidad />} />
                  <Route
                    path="/contabilidad/seguimiento"
                    element={
                      <InitDataNewOrderProvider>
                        <InitDataForTablesProvider>
                          <MaintenanceContabilidad />
                        </InitDataForTablesProvider>
                      </InitDataNewOrderProvider>
                    }
                  />
                </Routes>
              </div>
            </div>
          </div>
        </ViewportProvider>
      </InitDataProvider>
    </>
  );
}

export default IndexHome;
